import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { useState } from "react";
import QueryString from "qs";
import useSWR from "swr";
import { orderUrls } from "../../../Api/Auth/ApiUrls";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import Tabs from "../../../Components/Common/Tabs";
import { studentQuizBankTabsData } from "../../../data/SidebarData";
import { Loader } from "../../../Components/Common/Loader";
import { publicUrls, studentUrls } from "../../../Api/Auth/AppUrls";
import Button from "../../../Components/Common/Button";
import Accordion from "../../Home/Components/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import QuizModal from "./Components/QuizBankModal";
import { checkStudentRouteVisibility } from "../../../utils/findStudentRouteBySlug";
import NotFound from "../../Notfound";

const StudentQuizBank = () => {
  const { userData, categoryData } = useAuth();
  const location = useLocation();
  const [quizModalOpen, setQuizModalOpen] = useState(false);
  const [selectedSubchapter, setSelectedSubchapter] = useState(null);
  const isVisibleCivil = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentQuizBankCivil
  );
  const isVisibleMechanical = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentQuizBankMechanical
  );
  const visibleTabs = studentQuizBankTabsData.filter((tab) => {
    if (!tab?.path) return true;
    if (tab.path === studentUrls.studentQuizBankCivil && !isVisibleCivil)
      return false;
    if (tab.path === studentUrls.studentQuizBankMechanical && !isVisibleMechanical)
      return false;
    return true;
  });

  const apiQueryParams = {
    userId: userData?._id,
    itemType: "subscription",
    slug: location.pathname.split("/")[location.pathname.split("/").length - 1],
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);
  const { isLoading, data } = useSWR(orderUrls.purchases(apiQueryString));
  const startTest = (subchapter) => {
    setSelectedSubchapter(subchapter);
    setQuizModalOpen(true);
  };

  const dataRender = data?.data?.chapter?.map((item, index) => {
    return {
      title: item.title,
      content: (
        <div className="flex flex-col gap-3">
          <span className="font-normal text-xs">{item.description}</span>
          <div className="container mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-6 p-6">
            {item?.subchapters?.length ? (
              item?.subchapters?.map((sub) => (
                <div
                  key={sub._id}
                  className="border border-primary bg-white shadow-lg hover:shadow-xl rounded-lg p-4 transition-all duration-300"
                >
                  <h2 className="text-sm font-semibold text-center">
                    {sub.title}
                  </h2>
                  <div className="flex flex-col items-center gap-2 mt-3">
                    {sub?.questions?.length ? (
                      <Button size="small" onClick={() => startTest(sub)}>
                        <FontAwesomeIcon icon={faPlay} className="mr-2" />
                        Start Quiz
                      </Button>
                    ) : (
                      <span className="text-gray-500">
                        No available contents.
                      </span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <span className="mt-2 flex flex-col justify-center gap-2 text-center items-center">
                No available content.
              </span>
            )}
          </div>
        </div>
      ),
    };
  });
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={visibleTabs} />
      {!isVisibleCivil ? (
        <NotFound />
      ) : (
        <>
          {isLoading ? (
            <Loader />
          ) : // eslint-disable-next-line
            data?.data == {} ? (
              <span className=" mt-2  flex flex-col justify-center gap-2 text-center items-center">
                No available content. Purchase Quiz Bank to get started.
                <Link to={publicUrls.quizBankCivil}>
                  <Button>Quiz Bank</Button>
                </Link>
              </span>
            ) : data?.data?.purchased ? (
              (() => {
                // const purchaseInfo = data?.status;
                const purchasedAt = data?.data?.purchasedAt
                  ? new Date(data?.data?.purchasedAt)
                  : null;
                const duration = data?.data?.subscriptionDuration
                  ? parseInt(data?.data?.subscriptionDuration, 10)
                  : 0;

                if (!purchasedAt || isNaN(duration) || duration <= 0) {
                  return (
                    <div className="text-red-600 font-semibold">
                      ⚠️ Subscription data is missing or invalid.
                    </div>
                  );
                }

                const expirationDate = new Date(purchasedAt);
                expirationDate.setDate(expirationDate.getDate() + duration);

                const today = new Date();
                const remainingDays = Math.max(
                  0,
                  Math.ceil((expirationDate - today) / (1000 * 60 * 60 * 24))
                );

                return (
                  <>
                    <p className="font-semibold mt-4 mb-4">
                      <span className="text-gray-700">
                        {remainingDays > 0
                          ? ` Your subscription expires in ${remainingDays} day${remainingDays > 1 ? "s" : ""
                          }.`
                          : "Your subscription has expired."}
                      </span>
                    </p>
                    {data?.data?.chapter?.length ? (
                      <Accordion accordionData={dataRender} fullWidth openFirst />
                    ) : (
                      ""
                    )}
                  </>
                );
              })()
            ) : (
              <span className=" mt-2  flex flex-col justify-center gap-2 text-center items-center">
                No available content. Purchase Quiz Bank to get started.
                <Link to={publicUrls.quizBankCivil}>
                  <Button>Quiz Bank</Button>
                </Link>
              </span>
            )}
          {/* Quiz Modal */}
          <QuizModal
            isOpen={quizModalOpen}
            onClose={() => setQuizModalOpen(false)}
            questions={selectedSubchapter?.questions || []}
            subchapterTitle={selectedSubchapter?.title || ""}
          />
        </>
      )}
    </div>
  );
};

export default StudentQuizBank;
